const OneBrand = ({name,image}) => {
  return (
    <>
        <img src={image} alt={name} height={80}/>
    </>
  )
}

export default OneBrand